/**
 * StoreListPresenter
 * --
 */
import React, { useEffect, useState, useRef } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  TabMenu,
  Tabs,
  Descriptions,
  UploadFile,
  selectday,
  // Collapse,
  MenuList,
  KakaoMap,
  ModalLayout,
  Table,
  Text,
} from 'components';
import {
  Input,
  Button,
  Avatar,
  Calendar,
  DatePicker,
  Radio,
  Select,
  Divider,
  Tooltip as AntTooltip,
  Flex,
} from 'antd';
import moment from 'moment';
import dayjs from 'dayjs';
import MessageAlert, { stringToMoneyFormat, STORE_URL } from 'utils';
import { XAxis, YAxis, BarChart, Bar, Tooltip } from 'recharts';
import { openAddressModal } from 'utils/DaumAPIManager';
import Formatter from 'utils/Formatter';
import { downloadXlsx } from 'utils/XlsxDownloader';
import { QuestionCircleOutlined } from '@ant-design/icons';

const StoreListPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    data,
    stores,
    categoryData,
    tabItems,
    isOpened,
    modalType,
    modalData,
    files,
    selectedStore,
    menuSales,
    dailySales,
    dailyRefundSales,
    dailyCouponSales,
    isRefetch,
    onOpen,
    onChange,
    onSubmit,
    onDelete,
    onSelect,
    onCoordChange,
    setIsRefetch,
    setSelectday,
    onSalesMonthChange,
    onThumbnailFileChange,
    onMenuFileChange,
    onStoreFileChange,
    onLicenseFileChange,
    onEtcFileChange,
  } = props;

  // console.log('files', files);
  // console.log('selectedStore', selectedStore);
  // console.log('modalData', modalData);
  // console.log('categoryData', categoryData);

  /* ===== STATE ===== */
  // 선택한 매장 키
  const [selectedTabkey, setSelectedTabkey] = useState(null);
  const [keyword, setKeyword] = useState(null);
  // 선택한 아이템
  const [selectedItem, setSelectedItem] = useState(null);
  // 탭키
  const [tabKey, setTabKey] = useState(1);
  //
  const [selectedCategory, setSelectedCategory] = useState('');

  //
  const chartRef = useRef(null);
  //
  const [chartWidth, setChartWidth] = useState(0);

  const filteredData = React.useMemo(() => {
    return menuSales?.filter((item) => {
      const matchesCategory = selectedCategory
        ? item.product_category_id === parseInt(selectedCategory)
        : true;
      return matchesCategory;
    });
  }, [selectedCategory, menuSales]);
  //
  // const filteredData = menuSales?.filter((item) => {
  //   const matchesCategory = selectedCategory
  //     ? item.product_category_id === parseInt(selectedCategory)
  //     : true;
  //   return matchesCategory;
  // });
  const newTabItems = React.useMemo(() => {
    if (keyword) {
      return tabItems?.filter((item) => item?.label?.includes(keyword));
    }
    return tabItems;
  }, [keyword, tabItems]);

  /* ===== HOOKS ===== */
  useEffect(() => {
    const call = (e) => {
      setChartWidth(chartRef.current.clientWidth);
    };

    if (chartRef.current) call();

    window.addEventListener('resize', call);

    return () => {
      window.removeEventListener('resize', call);
    };
  }, [chartRef]);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
    tabTitle: {
      fontSize: 14,
      fontWeight: 600,
      color: '#404040',
    },
  };

  /* ===== FUNCTION ===== */
  /**
   * 다음 주소 검색 Popup Open
   * --
   */
  const handleOpen = () => {
    openAddressModal((res) => {
      onChange('shop_information_postcode', res.zonecode, 'store');
      onChange('shop_information_address', res.address, 'store');
    });
  };

  // 날짜별 매출을 표시하는 함수
  const dateCellRender = (value) => {
    const date = value.format('YYYY-MM-DD');
    const sales = dailySales[date];
    const refundSales = dailyRefundSales[date];
    const couponSales = dailyCouponSales[date];

    return sales || refundSales || couponSales ? (
      <div
        style={{
          position: 'absolute',
          top: 30,
          bottom: 4,
          right: 4,
          maxHeight: '20vh', // 화면 높이에 비례한 최대 높이
          overflowY: 'auto', // 스크롤 가능
          textAlign: 'right',
          padding: '8px',
          color: '#333',
          fontSize: 12,
          fontWeight: 500,
          scrollbarWidth: 'thin', // Firefox용 얇은 스크롤바
          scrollbarColor: 'rgba(0,0,0,0.2) transparent', // 스크롤바 색상
        }}
        className="scroll-container"
      >
        <div style={{ color: '#aba6a6' }}>매출</div>
        <div>{`${sales?.toLocaleString() || 0}원`}</div>
        <div style={{ color: '#aba6a6' }}>취소/환불</div>
        <div>{`${refundSales?.toLocaleString() || 0}원`}</div>
        <div style={{ color: '#aba6a6' }}>쿠폰/할인</div>
        <div>{`${couponSales?.toLocaleString() || 0}원`}</div>
      </div>
    ) : null;
  };

  //켈린더 클릭 시 해당 일자에 대응하는 menuSales 데이터 수정한 모달
  const onCalendarSelect = (newValue) => {
    const selectedDate = dayjs(newValue).format('YYYY-MM-DD');
    setSelectday(selectedDate); // 상태 업데이트
  };

  /**
   * 탭별 렌더링
   * --
   */
  const renderTabView = React.useCallback(() => {
    const view = {
      1: (
        <Row>
          {/* === 메뉴별 판매량 === */}
          <Col x={6}>
            <Content maxWidth={'100%'} padding={15}>
              <h4 style={{ ...styles.tabTitle, marginBottom: 10 }}>
                메뉴별 판매순위
              </h4>
              <div
                style={{
                  background: '#F4F4F4',
                  border: '1px solid #E6E6E6',
                  padding: '7px 10px',
                }}
              >
                {/* 제목 라벨 */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{ color: '#B9B9B9', fontSize: 12, fontWeight: 500 }}
                  >
                    메뉴명
                  </div>
                  <div
                    style={{ color: '#B9B9B9', fontSize: 12, fontWeight: 500 }}
                  >
                    판매수량
                  </div>
                </div>

                {/* 동적으로 데이터를 순회하여 메뉴별 판매순위 표시 */}
                {menuSales?.length > 0 ? (
                  menuSales?.slice(0, 10)?.map((item, index) => (
                    <div
                      key={`item_${index}`}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        paddingTop: 10,
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          flex: 1,
                          fontSize: 16,
                          fontWeight: 500,
                          color: '#6E6E6E',
                          lineHeight: '150%',
                        }}
                      >
                        {/* 순위 표시 */}
                        <span
                          style={{
                            width: 20,
                            textAlign: 'right',
                            marginRight: 10,
                          }}
                        >
                          {index + 1}.
                        </span>
                        {/* 메뉴 이름 표시 */}
                        <p>{item.menu_name}</p>
                      </div>
                      {/* 판매수량 표시 */}
                      <div
                        style={{
                          fontSize: 16,
                          fontWeight: 500,
                          color: '#6E6E6E',
                        }}
                      >
                        {item.num}
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    style={{
                      textAlign: 'center',
                      marginTop: 20,
                      color: '#B9B9B9',
                    }}
                  >
                    데이터가 없습니다.
                  </div>
                )}
              </div>

              {/* 전체 판매내역 보기 버튼 */}
              <Button
                type="primary"
                style={{
                  background: 'var(--primary-color)',
                  width: '100%',
                  marginTop: 10,
                }}
                onClick={() => onOpen(isOpened, 'menusales')}
              >
                판매내역 보기
              </Button>
              <Button
                type="default"
                style={{
                  width: '100%',
                  marginTop: 10,
                }}
                onClick={() => setSelectday(null)}
              >
                날짜 필터 해제
              </Button>
            </Content>
          </Col>

          {/* === 일별판매량 === */}
          <Col x={18}>
            <Content maxWidth={'100%'} padding={15}>
              <h4 style={{ ...styles.tabTitle }}>일별 판매량</h4>
              <div style={{ position: 'relative' }}>
                <style>
                  {`.custom-calendar .ant-radio-group {display: none !important;}`}
                </style>
                <Calendar
                  className="custom-calendar"
                  cellRender={dateCellRender}
                  onSelect={onCalendarSelect}
                  onPanelChange={onSalesMonthChange}
                />
              </div>
            </Content>
          </Col>
        </Row>
      ),
      2: (
        <Row>
          <Col x={8}>
            <Content maxWidth={'100%'} padding={10}>
              <h4
                style={{
                  ...styles.tabTitle,
                  height: 32,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                위치정보
              </h4>
              <div style={{ marginTop: 3 }}>
                <KakaoMap
                  address={selectedStore?.shop_information_address}
                  width={'100%'}
                />
              </div>
              <p
                style={{
                  textAlign: 'center',
                  marginTop: 10,
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#898989',
                }}
              >
                클릭하여 큰 이미지 보기
              </p>
            </Content>
          </Col>
          <Col x={16}>
            <Content maxWidth={'100%'} padding={10}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 3,
                }}
              >
                <h4 style={{ ...styles.tabTitle }}>기본정보</h4>
                <div>
                  <Button
                    type="primary"
                    style={{ background: 'var(--primary-color)' }}
                    onClick={() => {
                      if (!selectedTabkey) {
                        MessageAlert.warning(
                          '선택된 매장이 없습니다. 편집할 매장을 선택해주세요.'
                        );
                        return;
                      }
                      onOpen(isOpened, 'store', {
                        ...selectedStore,
                        business_num:
                          selectedStore?.store_information?.business_num,
                        store_num: selectedStore?.store_information?.store_num,
                        business_hour:
                          selectedStore?.store_information?.business_hour,
                        created_at: selectedStore?.created_at
                          ? Formatter.unixToDate(
                              selectedStore?.created_at,
                              'YYYY-MM-DD'
                            )
                          : null,
                        GROUP:
                          selectedStore?.store_information?.services?.GROUP, // 단체 이용가능여부
                        WIFI: selectedStore?.store_information?.services?.WIFI, // 무선 인터넷 사용 여부
                        PARKING:
                          selectedStore?.store_information?.services?.PARKING, // 주차 가능 여부
                        RESTROOM:
                          selectedStore?.store_information?.services?.RESTROOM, // 남녀 화장실 구분 여부
                        PACKAGING:
                          selectedStore?.store_information?.services?.PACKAGING, // 포장 가능 여부
                        WHEELCHAIR:
                          selectedStore?.store_information?.services
                            ?.WHEELCHAIR, // 출입구 휠체어 이용 가능 여부
                      });
                    }}
                  >
                    편집
                  </Button>
                  <Button
                    type="default"
                    onClick={() => {
                      if (!selectedTabkey) {
                        MessageAlert.warning(
                          '선택된 매장이 없습니다. 삭제처리할 매장을 선택해주세요.'
                        );
                        return;
                      }
                      window.confirm(
                        `정말 ${selectedStore?.shop_information_name} 을(를) 삭제처리 하시겠습니까?`
                      ) && onDelete();
                    }}
                  >
                    삭제
                  </Button>
                </div>
              </div>
              <Descriptions
                align="left"
                items={[
                  {
                    key: `1`,
                    label: '매장명',
                    children: `${selectedStore?.shop_information_name || '-'}`,
                  },
                  {
                    key: `2`,
                    label: '사업자등록번호',
                    children: `${
                      selectedStore?.store_information?.business_num || '-'
                    }`,
                  },
                  {
                    key: `3`,
                    label: '등록일',
                    children: `${
                      selectedStore?.created_at
                        ? moment(
                            Formatter.unixToDate(selectedStore?.created_at)
                          ).format('YYYY.MM.DD')
                        : '-'
                    }`,
                  },
                  {
                    key: `4`,
                    label: '대표자',
                    children: `${selectedStore?.store?.store_owner || '-'}`,
                  },
                  {
                    key: `5`,
                    label: '주소',
                    children: `${
                      selectedStore?.shop_information_address || '-'
                    } ${selectedStore?.shop_information_address_detail || ''}`,
                    span: 2,
                  },
                  {
                    key: `6`,
                    label: '전화번호',
                    children: `${
                      selectedStore?.store_information?.store_num || '-'
                    } / ${selectedStore?.admin?.admin_phone || '-'}`,
                    span: 2,
                  },
                  {
                    key: `7`,
                    label: '메뉴 수',
                    children: `${selectedStore?.menuCount || 0} 개`,
                  },
                  {
                    key: `8`,
                    label: '직원 수',
                    children: `${selectedStore?.staffs?.length || 0} 명`,
                  },
                  {
                    key: `10`,
                    label: '단체 이용',
                    children: (
                      <Radio.Group
                        options={[
                          { label: '가능', value: true },
                          { label: '불가능', value: false },
                        ]}
                        value={
                          selectedStore?.store_information?.services?.GROUP
                        }
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ),
                  },
                  {
                    key: `11`,
                    label: 'WIFI 이용',
                    children: (
                      <Radio.Group
                        options={[
                          { label: '가능', value: true },
                          { label: '불가능', value: false },
                        ]}
                        value={selectedStore?.store_information?.services?.WIFI}
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ),
                  },
                  {
                    key: `12`,
                    label: '주차 이용',
                    children: (
                      <Radio.Group
                        options={[
                          { label: '가능', value: true },
                          { label: '불가능', value: false },
                        ]}
                        value={
                          selectedStore?.store_information?.services?.PARKING
                        }
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ),
                  },
                  {
                    key: `13`,
                    label: '포장 이용',
                    children: (
                      <Radio.Group
                        options={[
                          { label: '가능', value: true },
                          { label: '불가능', value: false },
                        ]}
                        value={
                          selectedStore?.store_information?.services?.PACKAGING
                        }
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ),
                  },
                  {
                    key: `14`,
                    label: '휠체어 이용',
                    children: (
                      <Radio.Group
                        options={[
                          { label: '가능', value: true },
                          { label: '불가능', value: false },
                        ]}
                        value={
                          selectedStore?.store_information?.services?.WHEELCHAIR
                        }
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ),
                  },
                  {
                    key: `15`,
                    label: '남녀 화장실 구분 여부',
                    children: (
                      <Radio.Group
                        options={[
                          { label: '구분', value: true },
                          { label: '비구분', value: false },
                        ]}
                        value={
                          selectedStore?.store_information?.services?.RESTROOM
                        }
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ),
                  },
                  {
                    key: `16`,
                    label: '화장실 정보',
                    children: `${selectedStore?.toilet_information || '-'}`,
                    span: 2,
                  },
                  {
                    key: `17`,
                    label: 'WIFI 정보',
                    children: `${selectedStore?.wifi_information || '-'}`,
                    span: 2,
                  },
                  {
                    key: `9`,
                    label: '영업시간',
                    children: (
                      <div style={{ textAlign: 'left', padding: '20px 0' }}>
                        <pre>
                          {selectedStore?.store_information?.business_hour ||
                            '-'}
                        </pre>
                      </div>
                    ),
                  },
                  {
                    key: '18',
                    label: '매출 연결 매장',
                    children: `${
                      tabItems?.find(
                        (s) => s.key === selectedStore?.organization_id
                      )?.label || '최상위매장'
                    }`,
                  },
                ]}
              />
            </Content>
          </Col>
        </Row>
      ),
      3: (
        <Row>
          <Col x={6}>
            <Content maxWidth={'100%'} padding={0}>
              <Content
                maxWidth={'100%'}
                padding={0}
                backgroundColor="#FAFAFA"
                style={{ height: 800, overflow: 'auto' }}
              >
                {selectedStore?.shopMenus?.map((category) => (
                  <MenuList
                    key={`category_${category?.product_category_id}`}
                    title={category?.product_category_name}
                    data={category}
                    onMenuSelect={setSelectedItem}
                    selectedItem={selectedItem}
                  />
                ))}
                {/* {selectedStore?.shopMenus?.map((category) => (
                  <Collapse
                    key={`category_${category?.product_category_id}`}
                    title={category?.product_category_name}
                    defaultOpened
                  >
                    {category.subCategories?.length > 0
                      ? category.subCategories.map((subCategory) => (
                          <div
                            key={`subcategory_wrapper_${subCategory?.product_category_id}`}
                            style={{
                              marginLeft: '5%', // 하위 카테고리 들여쓰기
                              backgroundColor: '#f7f7f7', // 하위 카테고리 배경색 설정
                            }}
                          >
                            <Collapse
                              key={`subcategory_${subCategory?.product_category_id}`}
                              title={
                                <span style={{ paddingLeft: '20px' }}>
                                  {subCategory?.product_category_name}
                                </span>
                              }
                              defaultOpened
                            >
                              {subCategory?.menus?.map((menu) => (
                                <div
                                  key={`menu_${menu?.menu_id}`}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: 8,
                                    cursor: 'pointer',
                                    border:
                                      selectedItem?.menu_id === menu?.menu_id
                                        ? '1px solid #2394E4'
                                        : '1px solid #EFEFEF',
                                    borderBottom:
                                      selectedItem?.menu_id === menu?.menu_id
                                        ? '1px solid #2394E4'
                                        : '1px solid #DFDFDF',
                                    background:
                                      selectedItem?.menu_id === menu?.menu_id
                                        ? 'rgba(28, 107, 244, 0.3)'
                                        : '#EFEFEF',
                                  }}
                                  onClick={() => setSelectedItem(menu)}
                                >
                                  <div>
                                    <Avatar shape="square" size={30} />
                                  </div>
                                  <div style={{ paddingLeft: 7 }}>
                                    <h4>{menu?.menu_name}</h4>
                                    <p>
                                      {stringToMoneyFormat(menu?.price, '원')}
                                    </p>
                                  </div>
                                </div>
                              ))}
                            </Collapse>
                          </div>
                        ))
                      : // 상위 카테고리 메뉴
                        category?.menus?.map((menu) => (
                          <div
                            key={`menu_${menu?.menu_id}`}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: 8,
                              cursor: 'pointer',
                              border:
                                selectedItem?.menu_id === menu?.menu_id
                                  ? '1px solid #2394E4'
                                  : '1px solid #EFEFEF',
                              borderBottom:
                                selectedItem?.menu_id === menu?.menu_id
                                  ? '1px solid #2394E4'
                                  : '1px solid #DFDFDF',
                              background:
                                selectedItem?.menu_id === menu?.menu_id
                                  ? 'rgba(28, 107, 244, 0.3)'
                                  : '#EFEFEF',
                            }}
                            onClick={() => setSelectedItem(menu)}
                          >
                            <div>
                              <Avatar shape="square" size={30} />
                            </div>
                            <div style={{ paddingLeft: 7 }}>
                              <h4>{menu?.menu_name}</h4>
                              <p>{stringToMoneyFormat(menu?.price, '원')}</p>
                            </div>
                          </div>
                        ))}
                  </Collapse>
                ))} */}
              </Content>
              <div>
                {/* <Button
                  style={{
                    width: '50%',
                    borderRadius: 0,
                  }}
                >
                  카테고리 추가
                </Button>
                <Button
                  type="primary"
                  style={{
                    width: '50%',
                    background: 'var(--primary-color)',
                    borderRadius: 0,
                  }}
                >
                  메뉴 추가
                </Button> */}
              </div>
            </Content>
          </Col>
          <Col x={18}>
            <Content maxWidth={'100%'} padding={10}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 10,
                }}
              >
                <h4 style={{ ...styles.tabTitle }}>메뉴정보</h4>
              </div>
              <Descriptions
                align="left"
                column={3}
                items={[
                  {
                    key: 'menu_name',
                    label: '메뉴명',
                    children: selectedItem?.menu_name || '-',
                  },
                  {
                    key: 'menu_code',
                    label: '메뉴번호',
                    children: selectedItem?.menu_id || '-',
                  },
                  {
                    key: 'price',
                    label: '단가',
                    children: selectedItem?.price
                      ? stringToMoneyFormat(selectedItem.price, '원')
                      : '-',
                  },
                  {
                    key: 'menu_content',
                    label: '메뉴 설명',
                    children: selectedItem?.menu_content || '-',
                    span: 3,
                  },
                  {
                    key: 'temperature_option',
                    label: '온도 옵션',
                    children:
                      selectedItem?.temperature_option === 'ALL'
                        ? 'HOT / ICE'
                        : selectedItem?.temperature_option === 'HOT'
                        ? 'HOT ONLY'
                        : selectedItem?.temperature_option === 'ICE'
                        ? 'ICE ONLY'
                        : selectedItem?.temperature_option || '-',
                  },
                  {
                    key: 'type',
                    label: '메뉴 타입',
                    children:
                      selectedItem?.type === 'MD'
                        ? 'MD상품'
                        : selectedItem?.type === 'DESSERT'
                        ? '디저트'
                        : selectedItem?.type === 'ALC'
                        ? '주류'
                        : selectedItem?.type === 'ETC'
                        ? '기타'
                        : '일반',
                  },
                  {
                    key: 'is_show',
                    label: '노출 여부',
                    children: selectedItem?.is_show || '-',
                  },
                  {
                    key: 'menu_option',
                    label: '기타 옵션',
                    children:
                      selectedItem?.menu_option?.map((option, index) => (
                        <div
                          key={`option_${index}`}
                          style={{
                            padding: '10px 20px',
                            borderBottom:
                              index === selectedItem.menu_option.length - 1
                                ? 'none'
                                : '1px solid rgba(112, 115, 124, 0.2)',
                          }}
                        >
                          <Text size={13} weight={600} color={'#454545'}>
                            {option.option_title || 'Option'}
                          </Text>
                          <Radio.Group style={{ marginTop: 8 }} value="">
                            {option.option.map((optItem) => (
                              <Radio
                                key={`item_${optItem.option_key}`}
                                value={optItem}
                              >
                                {optItem.option_name || 'Option Name'}
                              </Radio>
                            ))}
                          </Radio.Group>
                        </div>
                      )) || '-',
                    span: 3,
                    style: { padding: 0 },
                  },
                  {
                    key: 'nutritional_information',
                    label: '영양 정보',
                    children:
                      selectedItem?.nutritional_information?.map(
                        (info, index) => (
                          <div
                            key={`nutritional_info_${index}`}
                            style={{ marginBottom: 10 }}
                          >
                            <Text size={13} weight={600} color={'#454545'}>
                              {info.nutritional_title}:{' '}
                              {info.nutritional_amount}
                              {info.nutritional_type}
                            </Text>
                          </div>
                        )
                      ) || '-',
                    span: 3,
                  },
                  {
                    key: 'allergen_ingredient',
                    label: '알레르기 유발 성분',
                    children: selectedItem?.allergen_ingredient || '-',
                    span: 3,
                  },
                  {
                    key: 'exchange_return_policy',
                    label: '교환/반품 안내',
                    children: selectedItem?.exchange_return_policy || '-',
                    span: 3,
                  },
                  {
                    key: 'is_present',
                    label: '선물 가능 여부',
                    children:
                      selectedItem?.is_present === 'Y'
                        ? '선물 가능'
                        : '선물 불가',
                    span: 3,
                  },
                  {
                    key: 'present_information',
                    label: '선물 관련 정보',
                    children: selectedItem?.present_information ? (
                      <div>
                        <div>
                          <strong>유효기간:</strong>{' '}
                          {
                            selectedItem.present_information
                              .present_expired_date
                          }
                          일
                        </div>
                        <div>
                          <strong>최대 연장 횟수:</strong>{' '}
                          {
                            selectedItem.present_information
                              .present_postponed_deadline
                          }
                          회
                        </div>
                      </div>
                    ) : (
                      '-'
                    ),
                    span: 3,
                  },
                  {
                    key: 'menu_file',
                    label: '이미지',
                    children: (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          padding: '20px 0px',
                        }}
                      >
                        {selectedItem?.menu_file
                          ?.filter((file) => file.type === 'THUMBNAIL')
                          ?.map((file, index) => (
                            <Avatar
                              key={`img_${index}`}
                              size={100}
                              shape="square"
                              style={{ marginRight: 10 }}
                              src={`${STORE_URL}/${file.file_url}`}
                            />
                          )) || '-'}
                        {selectedItem?.menu_file
                          ?.filter((file) => file.type !== 'THUMBNAIL')
                          ?.map((file, index) => (
                            <Avatar
                              key={`img_${index}`}
                              size={100}
                              shape="square"
                              style={{ marginRight: 10 }}
                              src={`${STORE_URL}/${file.file_url}`}
                            />
                          )) || '-'}
                      </div>
                    ),
                    span: 3,
                  },
                  {
                    key: `7`,
                    label: '매출',
                    children: (
                      <div style={{ padding: '20px 0px' }}>
                        <ul
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <li
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              paddingRight: 40,
                            }}
                          >
                            <span
                              style={{
                                width: 5,
                                height: 36,
                                background: '#0F6CBD',
                                marginRight: 5,
                              }}
                            ></span>
                            <div>
                              <Text
                                size={12}
                                color={'#424242'}
                                style={{ lineHeight: 1.25 }}
                              >
                                매출
                              </Text>
                              <Text
                                size={16}
                                weight={600}
                                color={'#424242'}
                                style={{ lineHeight: 1.25 }}
                              >
                                0원
                              </Text>
                            </div>
                          </li>
                          <li
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <span
                              style={{
                                width: 5,
                                height: 36,
                                background: '#C50F1F',
                                marginRight: 5,
                              }}
                            ></span>
                            <div>
                              <Text
                                size={12}
                                color={'#424242'}
                                style={{ lineHeight: 1.25 }}
                              >
                                판매비율
                              </Text>
                              <Text
                                size={16}
                                weight={600}
                                color={'#424242'}
                                style={{ lineHeight: 1.25 }}
                              >
                                0%
                              </Text>
                            </div>
                          </li>
                        </ul>
                        <div ref={chartRef} style={{ marginTop: 20 }}>
                          <BarChart
                            width={chartWidth}
                            height={300}
                            data={
                              // salesStatistic
                              []
                            }
                          >
                            <XAxis
                              dataKey={'day'}
                              stroke="#686C73"
                              // tickFormatter={(d) => moment(d).format('MM-DD')}
                            />
                            <YAxis stroke="#686C73" />
                            <Tooltip />
                            <Bar
                              dataKey={'sales'}
                              fill={'var(--primary-color)'}
                            />
                          </BarChart>
                        </div>
                      </div>
                    ),
                    span: 3,
                  },
                ]}
              />
            </Content>
          </Col>
        </Row>
      ),
      4: (
        <Row>
          <Col x={6}>
            <Content maxWidth={'100%'} padding={0}>
              <Content
                maxWidth={'100%'}
                padding={0}
                backgroundColor="#FAFAFA"
                style={{ height: 800, overflow: 'auto' }}
              >
                {selectedStore?.staffs?.map((_item, _index) => (
                  <div
                    key={`staff_${_index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: 8,
                      cursor: 'pointer',
                      border:
                        selectedItem?.staff_id === _item?.staff_id
                          ? '1px solid #2394E4'
                          : '1px solid #EFEFEF',
                      borderBottom:
                        selectedItem?.staff_id === _item?.staff_id
                          ? '1px solid #2394E4'
                          : '1px solid #DFDFDF',
                      background:
                        selectedItem?.staff_id === _item?.staff_id
                          ? 'rgba(28, 107, 244, 0.3)'
                          : '#EFEFEF',
                    }}
                    onClick={() => setSelectedItem(_item)}
                  >
                    <div>
                      <Avatar shape="square" size={30} />
                    </div>
                    <div style={{ paddingLeft: 7 }}>
                      <h4>{_item?.staff_name}</h4>
                      <p>{_item.staff_position}</p>
                    </div>
                  </div>
                ))}
              </Content>
              <div>
                <Button
                  type="primary"
                  style={{
                    width: '100%',
                    background: 'var(--primary-color)',
                    borderRadius: 0,
                  }}
                  onClick={() => onOpen(isOpened, 'staff')}
                >
                  직원 추가
                </Button>
              </div>
            </Content>
          </Col>
          <Col x={18}>
            <Content maxWidth={'100%'} padding={10}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 10,
                }}
              >
                <h4 style={{ ...styles.tabTitle }}>직원정보</h4>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <Button
                    type="primary"
                    style={{ background: 'var(--primary-color)' }}
                    onClick={() => {
                      if (!selectedItem) {
                        MessageAlert.warning(
                          '선택된 직원이 없습니다. 편집할 직원을 선택해주세요.'
                        );
                        return;
                      }

                      onOpen(isOpened, 'staff', {
                        ...selectedItem,
                        birthday: selectedItem?.birthday
                          ? Formatter.unixToDate(
                              selectedItem?.birthday,
                              'YYYY-MM-DD'
                            )
                          : null,
                        hire_date: selectedItem?.hire_date
                          ? Formatter.unixToDate(
                              selectedItem?.hire_date,
                              'YYYY-MM-DD'
                            )
                          : null,
                        termination_date: selectedItem?.termination_date
                          ? Formatter.unixToDate(
                              selectedItem?.termination_date,
                              'YYYY-MM-DD'
                            )
                          : null,
                      });
                    }}
                  >
                    편집
                  </Button>
                  <Button
                    type="default"
                    danger={true}
                    onClick={() => {
                      if (!selectedItem) {
                        MessageAlert.warning(
                          '직원이 없습니다. 삭제처리할 직원을 선택해주세요.'
                        );
                        return;
                      }
                      window.confirm(
                        `정말 ${selectedItem?.staff_name} 을(를) 삭제처리 하시겠습니까?`
                      ) && onDelete('staff', selectedItem.staff_id);
                    }}
                  >
                    삭제
                  </Button>
                </div>
              </div>
              <Descriptions
                align="left"
                items={[
                  {
                    key: `3`,
                    label: '직원명',
                    children: `${selectedItem?.staff_name || '-'}`,
                  },
                  {
                    key: `4`,
                    label: '직원 연락처',
                    children: `${selectedItem?.staff_phone || '-'}`,
                  },
                  {
                    key: `5`,
                    label: '생년월일',
                    children: `${
                      selectedItem?.birthday
                        ? moment(
                            Formatter.unixToDate(selectedItem?.birthday)
                          ).format('YYYY.MM.DD')
                        : '-'
                    }`,
                  },
                  {
                    key: `gender`,
                    label: '성별',
                    children: `${
                      selectedItem?.staff_gender
                        ? selectedItem?.staff_gender === 'M'
                          ? '남'
                          : '여'
                        : '-'
                    }`,
                  },
                  {
                    key: `staff_position`,
                    label: '직급',
                    children: `${selectedItem?.staff_position || '-'}`,
                  },
                  {
                    key: `work_type`,
                    label: '담당업무',
                    children: `${selectedItem?.work_type || '-'}`,
                  },
                  {
                    key: `hire_date`,
                    label: '입사일',
                    children: `${
                      selectedItem?.hire_date
                        ? moment(
                            Formatter.unixToDate(selectedItem?.hire_date)
                          ).format('YYYY.MM.DD')
                        : '-'
                    }`,
                  },
                  {
                    key: `termination_date`,
                    label: '퇴사일',
                    children: `${
                      selectedItem?.termination_date
                        ? moment(
                            Formatter.unixToDate(selectedItem?.termination_date)
                          ).format('YYYY.MM.DD')
                        : '-'
                    }`,
                  },
                  {
                    key: `staff_work_time`,
                    label: '근무시간',
                    children: (
                      <div style={{ textAlign: 'left', padding: '20px 0' }}>
                        <pre>{selectedItem?.staff_work_time || '-'}</pre>
                      </div>
                    ),
                  },
                ]}
              />
            </Content>
          </Col>
        </Row>
      ),
    };

    return view[tabKey];
    // eslint-disable-next-line
  }, [tabKey, selectedStore, selectedItem, menuSales]);

  useEffect(() => {
    setSelectedItem(null);
  }, [selectedStore]);
  /**
   * 선택한 매장 정보 정제
   * --
   */
  useEffect(() => {
    const store = data?.find(
      (_item) => _item.shop_information_id === selectedTabkey?.key
    );

    onSelect(store);
    // eslint-disable-next-line
  }, [selectedTabkey, data]);

  /**
   * 탭별 렌더링
   * --
   */
  useEffect(() => {
    renderTabView();
  }, [tabKey, selectedStore, renderTabView]);

  /**
   * 카테고리 필터링 초기화
   * --
   */
  useEffect(() => {
    setSelectedCategory('');
  }, [menuSales]);

  /**
   * 데이터 수정 시 렌더링 이슈 해결
   * --
   */
  useEffect(() => {
    if (selectedItem && isRefetch) {
      const { menu_id, staff_id } = selectedItem;

      let findData;
      if (menu_id) {
        findData = data
          ?.find((store) => {
            return store?.menus?.some((menu) => menu?.menu_id === menu_id);
          })
          ?.menus?.find((menu) => menu?.menu_id === menu_id);
      }

      if (staff_id) {
        findData = data
          ?.find((store) => {
            return store?.staffs?.some((staff) => staff?.staff_id === staff_id);
          })
          ?.staffs?.find((staff) => staff?.staff_id === staff_id);
      }

      setSelectedItem(findData);
      setIsRefetch(false);
    }
  }, [data, selectedItem, isRefetch, setIsRefetch]);

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title size={3} style={{ marginBottom: 12 }}>
              매장 관리
            </Title>

            <Row gutter={[2, 2]}>
              {/* === 매장목록: start === */}
              <Col x={4}>
                <Content
                  maxWidth={'100%'}
                  padding={5}
                  style={{ height: '100%' }}
                >
                  <Content
                    maxWidth={'100%'}
                    padding={5}
                    style={{ borderBottom: '1px solid #EBEBEB' }}
                  >
                    <Input
                      placeholder="매장명을 입력해주세요"
                      onChange={(e) => setKeyword(e.target.value)}
                    />
                  </Content>

                  <Content maxWidth={'100%'} padding={10}>
                    <TabMenu
                      items={newTabItems}
                      activeKey={selectedTabkey?.key}
                      onChange={(e) => setSelectedTabkey(e)}
                    />
                  </Content>
                </Content>
              </Col>
              {/* === 매장목록: end === */}

              {/* === 매장 설정: start === */}
              <Col x={20}>
                <Content
                  maxWidth={'100%'}
                  padding={5}
                  style={{ height: '100%' }}
                >
                  <div style={{ position: 'relative', top: 0, left: 0 }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        position: 'absolute',
                        top: '50%',
                        // left: 20,
                        transform: 'translate(0, -50%)',
                      }}
                    >
                      {/* <Avatar size={32} shape="square" /> */}
                      <h2
                        style={{
                          fontSize: 18,
                          fontWeight: 700,
                          color: '#242424',
                          lineHeight: '130%',
                          marginLeft: 10,
                        }}
                      >
                        {selectedTabkey?.label}
                      </h2>
                    </div>
                    <div style={{ paddingTop: 8 }}>
                      <Tabs
                        items={[
                          { label: '판매현황', key: 1 },
                          { label: '지점현황', key: 2 },
                          { label: '메뉴관리', key: 3 },
                          { label: '직원관리', key: 4 },
                        ]}
                        position="center"
                        activeKey={tabKey}
                        onChange={(e) => setTabKey(e)}
                      />
                    </div>
                  </div>

                  <div>{renderTabView()}</div>
                </Content>
              </Col>
              {/* === 매장 설정: end === */}
            </Row>
          </Col>
        </Row>
      </Content>

      {/* ===== 메뉴별 판매내역 모달: start ===== */}
      <ModalLayout
        type="modal"
        // centered
        title={'메뉴별 판매내역'}
        open={isOpened && modalType === 'menusales'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={'55%'}
        // footer={
        //   <Content
        //     maxWidth={'100%'}
        //     padding={0}
        //     style={{
        //       display: 'flex',
        //       justifyContent: 'center',
        //       alignItems: 'center',
        //       gap: 10,
        //     }}
        //   >
        //     <Button onClick={() => onOpen(isOpened)}>닫기</Button>
        //   </Content>
        // }
      >
        <Divider style={{ margin: '12px 0' }} />
        <Content maxWidth={'100%'} padding={0}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              textAlign: 'center',
            }}
          >
            <Title
              size={5}
              style={{ marginBottom: 10, alignItems: 'center' }}
              subButton={
                <Button
                  style={{ marginLeft: 8 }}
                  onClick={() => {
                    downloadXlsx({
                      columns: [
                        {
                          title: '카테고리 명',
                          key: 'product_category_name',
                          dataIndex: 'product_category_name',
                        },
                        {
                          title: '메뉴번호',
                          key: 'menu_id',
                          dataIndex: 'menu_id',
                        },
                        {
                          title: '메뉴명',
                          key: 'menu_name',
                          dataIndex: 'menu_name',
                        },
                        {
                          title: '판매수량',
                          key: 'num',
                          dataIndex: 'num',
                        },
                        {
                          title: '메뉴가격',
                          key: 'price',
                          dataIndex: 'price',
                        },
                      ],
                      rows: filteredData,
                      fileName: '메뉴별_판매내역',
                    });
                  }}
                >
                  엑셀로 다운로드
                </Button>
              }
            >
              카테고리 별 필터
            </Title>
            <Select
              size="small"
              style={{ width: 120 }}
              placeholder="상위 카테고리 선택 (선택사항)"
              value={selectedCategory}
              onChange={(value) => setSelectedCategory(value)}
              options={[
                { label: 'All', value: '' },
                ...(categoryData?.map((category) => ({
                  label: category.product_category_name,
                  value: category.product_category_id,
                })) || []),
              ]}
            />
          </div>
          {/* {(() => {
            console.log('filteredData: ', filteredData);
          })()} */}
          <Table
            data={filteredData} // 메뉴 데이터를 여기에 입력
            columns={[
              {
                title: '메뉴번호',
                key: 'menu_id',
                dataIndex: 'menu_id',
              },
              {
                title: '메뉴명',
                key: 'menu_name',
                dataIndex: 'menu_name',
              },
              {
                title: '판매수량',
                key: 'num',
                dataIndex: 'num',
                render: (item) => <span>{item}</span>,
              },
              {
                title: '메뉴가격',
                key: 'price',
                dataIndex: 'price',
                render: (price) => stringToMoneyFormat(price, '원'), // 가격 포맷
              },
            ]}
            minHeight={'auto'}
            minWidth={'100%'}
          />
        </Content>
      </ModalLayout>
      {/* ===== 전체판매내역 모달: end ===== */}

      <ModalLayout
        type="modal"
        centered
        title={'지점 정보'}
        open={isOpened && modalType === 'store'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={'50%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button type="primary" onClick={() => onSubmit('store', 'UPDATE')}>
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              {/* 매장 기본 정보 */}
              <Content maxWidth={'100%'} padding={0}>
                <Descriptions
                  items={[
                    {
                      key: 'shop_information_name',
                      label: (
                        <p>
                          매장명<span style={{ color: '#F94F1A' }}>*</span>
                        </p>
                      ),
                      children: (
                        <Input
                          size="large"
                          value={modalData?.store?.shop_information_name || ''}
                          placeholder="매장명을 입력해주세요"
                          onChange={(e) =>
                            onChange(
                              'shop_information_name',
                              e.target.value,
                              'store'
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'business_num',
                      label: '사업자등록번호',
                      children: (
                        <Input
                          size="large"
                          value={modalData?.store?.business_num || ''}
                          placeholder="사업자등록번호를 입력해주세요"
                          onChange={(e) =>
                            onChange(
                              'business_num',
                              Formatter.hyphen(e.target.value, 'business_num'),
                              'store'
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'created_at',
                      label: '등록일',
                      children: (
                        <DatePicker
                          size="large"
                          value={
                            modalData?.store?.created_at &&
                            dayjs(modalData?.store?.created_at)
                          }
                          style={{ width: '100%' }}
                          disabled
                        />
                      ),
                    },
                    {
                      key: 'owner_name',
                      label: '대표자',
                      children: (
                        <Input
                          size="large"
                          value={modalData?.store?.admin?.admin_name || ''}
                          placeholder="대표자명을 입력해주세요"
                          disabled
                        />
                      ),
                    },

                    {
                      key: 'address',
                      label: '주소',
                      span: 2,
                      children: (
                        <>
                          <div
                            style={{
                              width: '100%',
                              display: 'flex',
                              padding: '10px 0',
                              flexDirection: 'column', // 세로 정렬
                              alignItems: 'flex-start', // 왼쪽 정렬
                              gap: '10px', // 요소 간 간격
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                              }}
                            >
                              <Input
                                size="large"
                                value={
                                  modalData?.store?.shop_information_postcode ||
                                  ''
                                }
                                placeholder="우편번호"
                                readOnly
                                style={{ width: 300 }}
                              />
                              <Button size="large" onClick={() => handleOpen()}>
                                주소찾기
                              </Button>
                            </div>
                            <Input
                              size="large"
                              value={
                                modalData?.store?.shop_information_address || ''
                              }
                              placeholder="주소"
                              readOnly
                              style={{ width: 500 }}
                            />
                            <Input
                              size="large"
                              value={
                                modalData?.store
                                  ?.shop_information_address_detail || ''
                              }
                              onChange={(e) =>
                                onChange(
                                  'shop_information_address_detail',
                                  e.target.value,
                                  'store'
                                )
                              }
                              placeholder="상세주소"
                              style={{ width: 500 }}
                            />
                            <KakaoMap
                              width={500}
                              address={
                                modalData?.store?.shop_information_address || ''
                              }
                              name={
                                modalData?.store?.shop_information_name || ''
                              }
                              onChange={(lat, lng) => onCoordChange(lat, lng)}
                            />
                          </div>
                        </>
                      ),
                    },
                    {
                      key: 'store_num',
                      label: '전화번호',
                      span: 2,
                      children: (
                        <Input
                          size="large"
                          value={modalData?.store?.store_num || ''}
                          placeholder="전화번호를 입력해주세요"
                          onChange={(e) =>
                            onChange('store_num', e.target.value, 'store')
                          }
                        />
                      ),
                    },
                    {
                      key: 'toilet_information',
                      label: '화장실 정보',
                      span: 2,
                      children: (
                        <Input
                          size="large"
                          value={modalData?.store?.toilet_information || ''}
                          placeholder="화장실 정보를 입력해주세요"
                          onChange={(e) =>
                            onChange(
                              'toilet_information',
                              e.target.value,
                              'store'
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'wifi_information',
                      label: 'WIFI 정보',
                      span: 2,
                      children: (
                        <Input
                          size="large"
                          value={modalData?.store?.wifi_information || ''}
                          placeholder="WIFI 정보를 입력해주세요"
                          onChange={(e) =>
                            onChange(
                              'wifi_information',
                              e.target.value,
                              'store'
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'business_hour',
                      label: '영업시간',
                      span: 2,
                      children: (
                        <>
                          <Input.TextArea
                            value={modalData?.store?.business_hour || ''}
                            placeholder="영업시간을 입력해주세요"
                            style={{ minHeight: 80, margin: '10px 0' }}
                            onChange={(e) =>
                              onChange('business_hour', e.target.value, 'store')
                            }
                          />
                        </>
                      ),
                    },
                    {
                      key: 'thumbnail',
                      label: '매장 썸네일',
                      style: { padding: '10px 20px' },
                      children: (
                        <UploadFile
                          files={files.thumbnail}
                          preview
                          multiple
                          max={1}
                          onChange={onThumbnailFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'menu',
                      label: '메뉴판',
                      style: { padding: '10px 20px' },
                      children: (
                        <UploadFile
                          files={files.menu}
                          preview
                          multiple
                          max={1}
                          onChange={onMenuFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'store',
                      label: '매장 사진',
                      style: { padding: '10px 20px' },
                      children: (
                        <UploadFile
                          files={files.store}
                          preview
                          multiple
                          max={5}
                          onChange={onStoreFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'license',
                      label: '사업자등록증',
                      style: { padding: '10px 20px' },
                      children: (
                        <UploadFile
                          files={files.license}
                          preview
                          multiple
                          max={1}
                          onChange={onLicenseFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'etc',
                      label: '기타',
                      style: { padding: '10px 20px' },
                      children: (
                        <UploadFile
                          files={files.etc}
                          preview
                          multiple
                          max={3}
                          onChange={onEtcFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'GROUP',
                      label: '단체 이용',
                      children: (
                        <>
                          <Radio.Group
                            options={[
                              { label: '가능', value: true },
                              { label: '불가능', value: false },
                            ]}
                            onChange={(e) =>
                              onChange('GROUP', e.target.value, 'store')
                            }
                            value={modalData?.store?.GROUP}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </>
                      ),
                    },
                    {
                      key: 'WIFI',
                      label: 'WIFI 이용',
                      children: (
                        <>
                          <Radio.Group
                            options={[
                              { label: '가능', value: true },
                              { label: '불가능', value: false },
                            ]}
                            onChange={(e) =>
                              onChange('WIFI', e.target.value, 'store')
                            }
                            value={modalData?.store?.WIFI}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </>
                      ),
                    },
                    {
                      key: 'PARKING',
                      label: '주차 이용',
                      children: (
                        <>
                          <Radio.Group
                            options={[
                              { label: '가능', value: true },
                              { label: '불가능', value: false },
                            ]}
                            onChange={(e) =>
                              onChange('PARKING', e.target.value, 'store')
                            }
                            value={modalData?.store?.PARKING}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </>
                      ),
                    },
                    {
                      key: 'PACKAGING',
                      label: '포장 이용',
                      children: (
                        <>
                          <Radio.Group
                            options={[
                              { label: '가능', value: true },
                              { label: '불가능', value: false },
                            ]}
                            onChange={(e) =>
                              onChange('PACKAGING', e.target.value, 'store')
                            }
                            value={modalData?.store?.PACKAGING}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </>
                      ),
                    },
                    {
                      key: 'WHEELCHAIR',
                      label: '휠체어 이용',
                      children: (
                        <>
                          <Radio.Group
                            options={[
                              { label: '가능', value: true },
                              { label: '불가능', value: false },
                            ]}
                            onChange={(e) =>
                              onChange('WHEELCHAIR', e.target.value, 'store')
                            }
                            value={modalData?.store?.WHEELCHAIR}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </>
                      ),
                    },
                    {
                      key: 'RESTROOM',
                      label: '남녀 화장실 구분 여부',
                      children: (
                        <>
                          <Radio.Group
                            options={[
                              { label: '구분', value: true },
                              { label: '비구분', value: false },
                            ]}
                            onChange={(e) =>
                              onChange('RESTROOM', e.target.value, 'store')
                            }
                            value={modalData?.store?.RESTROOM}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </>
                      ),
                    },
                    {
                      key: 'organization_id',
                      label: '매출 연결 매장',
                      children: (
                        <Flex gap={5} align="center">
                          <AntTooltip
                            overlayStyle={{ maxWidth: 500 }}
                            title={
                              <p>
                                * 매출을 연결할 상위 매장을 선택할 수 있습니다.{' '}
                                <br />* 하위 매장이 존재할 경우에 선택할 수
                                없습니다.
                              </p>
                            }
                          >
                            <QuestionCircleOutlined />
                          </AntTooltip>
                          <Select
                            size="large"
                            style={{ width: '100%' }}
                            options={[
                              { label: '최상위설정', value: null },
                              ...(Array.isArray(tabItems) // tabItems가 배열인지 먼저 확인
                                ? tabItems.filter(
                                    (item) =>
                                      item?.key !==
                                      modalData?.store?.shop_information_id
                                  )
                                : []), // 배열이 아니면 빈 배열을 펼침으로써 오류 방지
                            ]}
                            value={modalData?.store?.organization_id || null}
                            disabled={stores?.some(
                              (s) =>
                                s.organization_id ===
                                modalData?.store?.shop_information_id
                            )}
                            onChange={(e) =>
                              onChange('organization_id', e, 'store')
                            }
                          />
                        </Flex>
                      ),
                    },
                  ]}
                />
              </Content>
              <br />
              {/* 매장 파일 정보
              <Content maxWidth={'100%'} padding={0}>
                <Descriptions
                  items={[
                    {
                      key: 'thumbnail',
                      label: '매장 썸네일',
                      children: (
                        <UploadFile
                          files={files.thumbnail}
                          preview
                          multiple
                          max={1}
                          onChange={onThumbnailFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'menu',
                      label: '메뉴판',
                      children: (
                        <UploadFile
                          files={files.menu}
                          preview
                          multiple
                          max={1}
                          onChange={onMenuFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'store',
                      label: '매장 사진',
                      children: (
                        <UploadFile
                          files={files.store}
                          preview
                          multiple
                          max={5}
                          onChange={onStoreFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'license',
                      label: '사업자등록증',
                      children: (
                        <UploadFile
                          files={files.license}
                          preview
                          multiple
                          max={1}
                          onChange={onLicenseFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'etc',
                      label: '기타',
                      children: (
                        <UploadFile
                          files={files.etc}
                          preview
                          multiple
                          max={3}
                          onChange={onEtcFileChange}
                        />
                      ),
                      span: 2,
                    },
                  ]}
                />
              </Content> */}
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      <ModalLayout
        type="modal"
        centered
        title={'직원 추가/편집'}
        open={isOpened && modalType === 'staff'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={'50%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button
              type="primary"
              onClick={() =>
                onSubmit(
                  'staff',
                  modalData?.staff?.staff_id ? 'UPDATE' : 'CREATE'
                )
              }
            >
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Descriptions
                  items={[
                    {
                      key: 'staff_name',
                      label: (
                        <p>
                          직원명<span style={{ color: '#F94F1A' }}>*</span>
                        </p>
                      ),
                      children: (
                        <Input
                          size="large"
                          value={modalData?.staff?.staff_name}
                          placeholder="직원명을 입력해주세요"
                          onChange={(e) =>
                            onChange('staff_name', e.target.value, 'staff')
                          }
                        />
                      ),
                    },
                    {
                      key: 'staff_phone',
                      label: '연락처',
                      children: (
                        <Input
                          size="large"
                          value={modalData?.staff?.staff_phone}
                          placeholder="연락처를 입력해주세요"
                          maxLength={13}
                          onChange={(e) =>
                            onChange(
                              'staff_phone',
                              Formatter.hyphen(e.target.value),
                              'staff'
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'birthday',
                      label: '생년월일',
                      children: (
                        <DatePicker
                          size="large"
                          value={
                            modalData?.staff?.birthday &&
                            dayjs(modalData?.staff?.birthday)
                          }
                          placeholder="생년월일을 선택해주세요"
                          style={{ width: '100%' }}
                          onChange={(_, dateString) =>
                            onChange('birthday', dateString, 'staff')
                          }
                        />
                      ),
                    },
                    {
                      key: 'staff_gender',
                      label: '성별',
                      children: (
                        <Radio.Group
                          value={
                            modalData?.staff?.staff_gender ??
                            onChange('staff_gender', 'M', 'staff')
                          }
                          onChange={(e) =>
                            onChange('staff_gender', e.target.value, 'staff')
                          }
                        >
                          <Radio value={'M'}>남</Radio>
                          <Radio value={'F'}>여</Radio>
                        </Radio.Group>
                      ),
                    },
                    {
                      key: 'staff_position',
                      label: '직급',
                      children: (
                        <Input
                          size="large"
                          value={modalData?.staff?.staff_position}
                          placeholder="직급을 입력해주세요"
                          maxLength={13}
                          onChange={(e) =>
                            onChange('staff_position', e.target.value, 'staff')
                          }
                        />
                      ),
                    },
                    {
                      key: 'work_type',
                      label: '담당업무',
                      children: (
                        <Input
                          size="large"
                          value={modalData?.staff?.work_type}
                          placeholder="담당업무를 입력해주세요"
                          maxLength={13}
                          onChange={(e) =>
                            onChange('work_type', e.target.value, 'staff')
                          }
                        />
                      ),
                    },
                    {
                      key: 'hire_date',
                      label: '입사일',
                      children: (
                        <DatePicker
                          size="large"
                          value={
                            modalData?.staff?.hire_date &&
                            dayjs(modalData?.staff?.hire_date)
                          }
                          placeholder="입사일을 선택해주세요"
                          style={{ width: '100%' }}
                          onChange={(_, dateString) =>
                            onChange('hire_date', dateString, 'staff')
                          }
                        />
                      ),
                    },
                    {
                      key: 'termination_date',
                      label: '퇴사일',
                      children: (
                        <DatePicker
                          size="large"
                          placeholder="퇴사일을 선택해주세요"
                          value={
                            modalData?.staff?.termination_date &&
                            dayjs(modalData?.staff?.termination_date)
                          }
                          style={{ width: '100%' }}
                          onChange={(_, dateString) =>
                            onChange('termination_date', dateString, 'staff')
                          }
                        />
                      ),
                    },
                    {
                      key: 'staff_work_time',
                      label: '근무시간',
                      span: 2,
                      children: (
                        <div style={{ padding: '20px 0px' }}>
                          <Input.TextArea
                            size="large"
                            value={modalData?.staff?.staff_work_time}
                            placeholder="설명을 입력해주세요"
                            count={{
                              show: true,
                              max: 130,
                            }}
                            style={{ minHeight: 78 }}
                            onChange={(e) =>
                              onChange(
                                'staff_work_time',
                                e.target.value,
                                'staff'
                              )
                            }
                          />
                        </div>
                      ),
                    },
                  ]}
                />
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default StoreListPresenter;
